// extracted by mini-css-extract-plugin
export default {"wrapper":"about_wrapper__Q2p4+","firstBanner":"about_firstBanner__N+94Z","content":"about_content__kJOji","story":"about_story__fkkTH"};